<template lang="pug">
el-dialog(
  title="修改",
  :close-on-click-modal="false",
  :visible.sync="visible",
  :modal-append-to-body="false",
  width="90%"
) 
  |
  |
  |
  |
  |
  |
  el-card(shadow="never")
    div(slot="header")
      font(style="font-weight: bold; font-size: 18px") 加盟费配置
        div
          el-table(:data="dataList")
            el-table-column(
              prop="category",
              header-align="center",
              align="center",
              label="费用配置项",
              width="300"
            )
              template(slot-scope="scope")
                span {{scope.row.categoryName}}
            el-table-column(
              prop="calType",
              header-align="center",
              align="center",
              label="配置类型"
            )
              template(slot-scope="scope")
                el-radio(v-model="scope.row.calType", :label="1") 固定金额
                el-input(
                  v-model="scope.row.fixedAmount",
                  :disabled="scope.row.calType != 1",
                  @change="valChange(scope)"
                )
            el-table-column(
              prop="feeEnrollMin",
              header-align="center",
              align="center",
              label="判定额度(元)"
            )
              template(slot-scope="scope")
                el-radio(v-model="scope.row.calType", :label="2") 百分比
                el-input(
                  v-model="scope.row.percentage",
                  :disabled="scope.row.calType != 2",
                  @change="valChange(scope)",
                  type="number",
                  max=100
                )
      font(style="font-weight: bold;")
        div(style="margin-top: 20px;font-size: 18px;") 提现手续费配置
        div
          el-table(:data="withdrawalFeesList")
            el-table-column(
              align="center",
              width="300"
            )
              template(slot-scope="scope")
                span {{scope.row.categoryName}}
            el-table-column(
              align="center",
              width="670"
            )
              template(slot-scope="scope")
                el-radio(v-model="scope.row.calType", :label="2") 百分比
                el-input(
                  v-model="scope.row.percentage",
                  :disabled="scope.row.calType != 2",
                  @change="valChange(scope)",
                  type="number",
                  max=100
                )
      font(style="font-weight: bold;")
        div(style="margin-top: 20px;")
          span(style="font-size: 18px;") 限额配置
          span(style="margin-right: 10px; font-size: 14px;") （比赛、培训等服务收取的最低费用）
        div
          el-table(:data="dataList1")
            el-table-column(
              prop="category",
              header-align="center",
              align="center",
              label="费用配置项",
              width="300"
            )
              template(slot-scope="scope")
                span {{scope.row.categoryName}}
            el-table-column(
              prop="calType",
              header-align="center",
              align="center",
              label="配置类型",
              width="670"
            )
              template(slot-scope="scope")
                el-radio(v-model="scope.row.calType", :label="1") 固定金额
                el-input(
                  v-model="scope.row.fixedAmount",
                  @change="valChange1(scope)"
                )
            //- el-table-column(
            //-   prop="feeEnrollMin",
            //-   header-align="center",
            //-   align="center",
            //-   label="判定额度(元)"
            //- )
            //-   template(slot-scope="scope")
            //-     el-radio(v-model="scope.row.calType", :label="2") 百分比
            //-     el-input(v-model="scope.row.percentage")
  span.dialog-footer(slot="footer")
    el-button(@click="save") 保存
    el-button(@click="visible = false") 取消
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      id: "",
      sysOrgId: "",
      dataList: [],
      dataList1: [],
      withdrawalFeesList: []
    };
  },
  methods: {
    init1(sysOrgId, id) {
      (this.id = id), (this.sysOrgId = sysOrgId);
      this.visible = true;
      this.$http({
        url: this.$http.adornUrl("/frInitialFeeSetting/getBySysOrgId"),
        method: "get",
        params: {
          sysOrgId: sysOrgId,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.dataList = data.data.initialFeeModels;
          this.dataList1 = data.data.limitFeeModels;
          this.withdrawalFeesList = [{ categoryName: "提现手续费", percentage: data.data.withdrawalFees, calType: 2 }];
        }
      });
    },
    valChange(scope) {
      let reg=/^(([1-9]\d*)|0|([0][.]{1}[0-9]{0,2}[1-9]+)|([1-9]\d*[.]{1}[0-9]+))$/
      if (scope.row.calType == 1) {
        if (!reg.test(scope.row.fixedAmount) || scope.row.fixedAmount == "") {
          scope.row.fixedAmount = 0;
          this.$message.error("固定金额应大于等于0");
        }
      }

      if (scope.row.calType == 2) {
        if (!reg.test(scope.row.percentage) || scope.row.percentage == "") {
          scope.row.percentage = 0;
          this.$message.error("百分比应大于等于0");
        }
      }
    },
    valChange1(scope) {
      let reg=/^(([1-9]\d*)|0|([0][.]{1}[0-9]{0,2}[1-9]+)|([1-9]\d*[.]{1}[0-9]+))$/
      if (!reg.test(scope.row.fixedAmount) || scope.row.fixedAmount == "") {
        scope.row.fixedAmount = 0;
        this.$message.error("固定金额应大于等于0");
      }
    },
    save() {
      let params = {
        id: this.id,
        sysOrgId: this.sysOrgId,
        initialFeeModels: this.dataList,
        limitFeeModels: this.dataList1,
        withdrawalFees: this.withdrawalFeesList[0].percentage
      };
      this.$http({
        url: this.$http.adornUrl("/frInitialFeeSetting/saveOrUpdate"),
        method: "post",
        data: params,
      }).then((data) => {
        if (data && data.code === 0) {
          // this.$emit("refreshdatalist");
          // this.$message.success("保存成功");
          // this.visible = false;

          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.$emit("refreshdatalist");
              this.$message.success("保存成功");
              this.visible = false;
              this.$showLoading("close");
            },
          });
        } else {
        }
      });
    },
  },
};
</script>
<style >
pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
* {
  margin: 0px;
}
.el-table td.is-center,
.el-table th.is-center {
  text-align: left;
}
.el-input {
  width: 80% !important;
}

.el-dialog__wrapper .el-table thead {
  display: none;
}
</style>